import { certificateSelection } from '~/utils/certificate-route.mjs';

export default defineNuxtRouteMiddleware(to => {
  if (!certificateSelection(to.query)) return navigateTo('/library', { replace: true });
});
